import {assert, generateHeapObjID} from "../../util/TraceUtil";
import React from "react";
import {cleanupSuTypeLabelForCss} from "./RenderUtil";

export const renderCStructArray = (obj, renderNestedObject,lang) => {
  if (obj[0] === 'C_STRUCT' || obj[0] === 'C_UNION') {
    assert(obj.length >= 3);
    const addr = obj[1];
    const metadata = obj[2];
    const typename = metadata.name;
    const suBaseAddr = cleanupSuTypeLabelForCss('cdata_' + addr + '--SUBASE--' + typename);
    const suCssId = generateHeapObjID(suBaseAddr);
    const typeLabel = (obj[0] === 'C_STRUCT'? (lang === 'cpp' ? 'object' : 'struct'): 'union') + ' ' + typename;
    const values = obj.slice(3);
    return <>
      <div className="cStructUnion">
        <div className="typeLabel" id={suCssId}>{typeLabel}</div>
        <table className="instTbl">
          <tbody>
          {values.map((kvPair, i) =>{
            const fieldName = kvPair[0];
            if (fieldName === '<padding>') {
              return <></>;
            }
            return(
            <tr key={i} className="instEntry">
              <td className="instKey"><span className="keyObj">{fieldName}</span></td>
              <td className="instVal">
                {renderNestedObject(kvPair[1])}
              </td>
            </tr>
          )})}
          </tbody>
        </table>
      </div>
    </>
  } else if (obj[0] === 'C_MULTIDIMENSIONAL_ARRAY') {
    // // since we can display only 2 dimensions sensibly, make the first
    // // dimension into rows and flatten all other dimensions together into
    // // columns. in the common case for a 2-D array, this will do the
    // // perfect thing: first dimension is rows, second dimension is columns.
    // // e.g., for a 4-D array, the first dimension is rows, and dimensions
    // // 2, 3, and 4 are flattened together into columns. we can't do
    // // any better than this since it doesn't make sense to display
    // // more than 2 dimensions at once on screen
    // assert(obj.length >= 3);
    // var addr = obj[1];
    // var metadata = obj[2];
    // var dimensions = metadata.dimensions;
    // assert(dimensions.length > 1); // make sure we're really multidimensional!
    // // put everything here inside of a cArray div ...
    // const wrapperElt = $('<div class="cArray"></div>')
    //   .appendTo(d3DomElement);
    // wrapperElt.append('<div class="typeLabel">array</div>');
    // wrapperElt.append('<table class="cArrayTbl"></table>');
    // const tbl = wrapperElt.children('table');
    // // a list of array indices for each dimension
    // var indicesByDimension = [];
    // for (var d = 0; d < dimensions.length; d++) {
    //   indicesByDimension.push(d3.range(dimensions[d]));
    // }
    // // common case is 2-D:
    // var allDimensions = multiplyLists(indicesByDimension[0], indicesByDimension[1]);
    // // for all dimensions above the second one ...
    // for (var d = 2; d < dimensions.length; d++) {
    //   allDimensions = multiplyLists(allDimensions, indicesByDimension[d]);
    // }
    // //console.log('allDimensions', JSON.stringify(allDimensions));
    // // ignore dimensions[0], which is rows
    // var numColumns = 1;
    // for (var i = 1; i < dimensions.length; i++) {
    //   numColumns *= dimensions[i];
    // }
    // for (var row = 0; row < dimensions[0]; row++) {
    //   //console.log('row', row);
    //   // a pair of rows for header + content, respectively
    //   tbl.append('<tr></tr>');
    //   const headerTr = tbl.find('tr:last');
    //   tbl.append('<tr></tr>');
    //   const contentTr = tbl.find('tr:last');
    //   for (var col = 0; col < numColumns; col++) {
    //     var flattenedInd = (row * numColumns) + col; // the real index into the 1-D flattened array stored in obj[3:]
    //     var realInd = flattenedInd + 3; // skip 3 header fields to get to the real index in obj
    //     var val = obj[realInd];
    //     var indToDisplay = allDimensions[flattenedInd].join(',');
    //     //console.log('  col', col, '| flattenedInd:', flattenedInd, indToDisplay, 'contents:', val);
    //     // add a new column and then pass in that newly-added column
    //     // as d3DomElement to the recursive call to child:
    //     headerTr.append('<td class="cMultidimArrayHeader"></td>');
    //     headerTr.find('td:last').append(indToDisplay);
    //     contentTr.append('<td class="cMultidimArrayElt"></td>');
    //     myViz.renderNestedObject(val, stepNum, contentTr.find('td:last'));
    //   }
    // }
  }
  else {
    assert(obj[0] === 'C_ARRAY');
    if (obj.length <= 3){
      return <></>
    }
    const base_addr = obj[1]; // base address of array's first element
    const metadata = obj[2];
    const oob_addr = metadata.oob_addr; // first oob (out-of-bounds) address, which is right after the last element
    const values = obj.slice(3);
    return <>
      <div className="cArray">
        <div className="typeLabel">array</div>
        <table className="cArrayTbl">
          <tbody>
          <tr>
            {values.map((_, i) =>
              <td key={i} className="cArrayHeader">{i}</td>
            )}
          </tr>
          <tr>
            {values.map((v, i) => {

              return <td key={i} className="cArrayElt">
                {renderNestedObject(v)}
                </td>
            })}
          </tr>
          </tbody>
        </table>
      </div>
    </>
  }
  // append a footer at the bottom of d3DomElement if special properties are set:
  if (obj.readonlyMemory) {
    // d3DomElement.append('<div class="readonlyMemoryFooter">(this is in read-only storage, not the heap)</div>');
  //} else if (isPlainObject(obj.cppTypePunning)) {
    // d3DomElement.append(`<div class="typePunningFooter">
    //     type punning:
    //     view ${obj.cppTypePunning.selectedIndex + 1} of ${obj.cppTypePunning.values.length}
    //     <br/>[<a class="typePunningSwitcher" href="javascript:void(0);">switch views</a>]
    //   </div>`);
    // d3DomElement.find('.typePunningSwitcher').click(() => {
    //   // increment selectedIndex and wrap-around
    //   obj.cppTypePunning.selectedIndex = (obj.cppTypePunning.selectedIndex + 1) % obj.cppTypePunning.values.length;
    //   assert(obj.cppTypePunning.selectedIndex >= 0 && obj.cppTypePunning.selectedIndex < obj.cppTypePunning.values.length);
    //   // now set this and then re-render the visualization with the *new* selectedIndex:
    //   myViz.cppTypePunningSelections.set(obj.cppTypePunning.memAddr, obj.cppTypePunning.selectedIndex);
    //   myViz.owner.updateOutput(); // <-- should re-render the entire current step from scratch and use new value of selectedIndex from cppTypePunningSelections
    // });
  }
  return <>todo renderCStructArray {obj[0]}</>
}